import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import { post } from '../../api/api';

import { ndjsonParser } from '../../api/util/ndjson-parser';

export type TranslateMessageStreamResponse = {
  key: string;
  value: string;
};

export const translateMessage = (messageTranslationRequest: MessageTranslationRequest) =>
  createGenericDispatcher<void>({
    name: 'TRANSLATE_MESSAGE',
    loadFunction: () =>
      post('/message-translation/translate', {
        body: JSON.stringify(messageTranslationRequest),
      }),
    args: { messageTranslation: messageTranslationRequest },
    parseStreamChunk: ndjsonParser,
  });
